import { supabase, TABLES } from "../lib/supabase";

export interface CurrentWorkerProfile {
  id: number;
  user_id: string;
  role_id: number;
  organization: string;
  active: boolean;
}

let cachedWorker: CurrentWorkerProfile | null = null;
let cachedForUserId: string | null = null;

export function clearCurrentWorkerCache() {
  cachedWorker = null;
  cachedForUserId = null;
}

export async function getCurrentWorkerProfile(): Promise<CurrentWorkerProfile> {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();

  if (userError || !user) {
    throw new Error("No active authenticated user found");
  }

  if (cachedWorker && cachedForUserId === user.id) {
    return cachedWorker;
  }

  const { data, error } = await supabase
    .from(TABLES.WORKERS)
    .select("id,user_id,role_id,organization,active")
    .eq("user_id", user.id)
    .eq("active", true)
    .single();

  if (error) {
    throw new Error(`Failed to load current worker profile: ${error.message}`);
  }

  if (!data?.organization) {
    throw new Error("Current worker has no organization assigned");
  }

  cachedWorker = {
    id: data.id,
    user_id: data.user_id,
    role_id: data.role_id,
    organization: data.organization,
    active: Boolean(data.active),
  };
  cachedForUserId = user.id;

  return cachedWorker;
}
